export default {
  placeholder: 'Søg brand...',
};
